
/**
 * Test connection to the Frank API
 */
export const testFrankApiConnection = async (apiUrl: string): Promise<{ok: boolean, statusCode?: number, statusText?: string}> => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    
    console.log("Testing connection to Frank API at:", apiUrl);
    
    // First try the health endpoint
    let response = await fetch(`${apiUrl}/health`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);
    
    // If health endpoint doesn't exist, try a simple OPTIONS request to root
    if (response.status === 404) {
      const optionsController = new AbortController();
      const optionsTimeoutId = setTimeout(() => optionsController.abort(), 5000);
      
      response = await fetch(apiUrl, {
        method: "OPTIONS",
        signal: optionsController.signal,
      });
      
      clearTimeout(optionsTimeoutId);
    }
    
    // If still not successful, try a GET request to the root URL
    if (!response.ok) {
      const getRootController = new AbortController();
      const getRootTimeoutId = setTimeout(() => getRootController.abort(), 5000);
      
      response = await fetch(apiUrl, {
        method: "GET",
        signal: getRootController.signal,
      });
      
      clearTimeout(getRootTimeoutId);
    }
    
    return {
      ok: response.ok,
      statusCode: response.status,
      statusText: response.statusText
    };
  } catch (error) {
    console.error("Error testing Frank API connection:", error);
    return {
      ok: false,
      statusText: error instanceof Error ? error.message : "Unknown error"
    };
  }
};
